/* VENZE · Caja de compra (web v2, ronda 4, 30 oct). Tres tarjetas (mensual, trimestral, compra única), línea de llegada,
   reseña rotando, galería con segmentos, añadir al carrito (abre el carrito lateral de Horizon), caja fija en escritorio
   y píldora en móvil con opción, precio tachado, precio y ventajas. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.vbxReady) return;
    root.dataset.vbxReady = '1';

    /* Vista previa: ?vbx=marked|black|gradient|fill, ?pill=frost|glass|solid y ?title=ext|lt cambian el estilo para comparar */
    try {
      var qs = new URLSearchParams(window.location.search);
      if (/^(marked|black|gradient|fill)$/.test(qs.get('vbx') || '')) root.dataset.style = qs.get('vbx');
      if (/^(frost|solid|glass)$/.test(qs.get('pill') || '')) root.dataset.pill = qs.get('pill');
      if (/^(ext|lt)$/.test(qs.get('title') || '')) root.dataset.title = qs.get('title');
    } catch (e) { /* sin parámetros */ }

    var dataEl = root.querySelector('[data-vbx-data]');
    var opts = [];
    try { opts = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { opts = []; }

    var state = { opt: Math.min(parseInt(root.dataset.opt || '0', 10) || 0, Math.max(opts.length - 1, 0)) };

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var addBtns = $$('[data-vbx-add]');
    var mainAdd = $('.vbx-add');
    var addLabel = $('[data-vbx-add-label]');
    var defaultAddText = mainAdd ? mainAdd.dataset.addText : '';
    var soonText = mainAdd ? mainAdd.dataset.soonText : '';

    function current() { return opts[state.opt] || null; }

    function render() {
      var c = current();
      if (!c) return;
      root.dataset.opt = String(state.opt);
      $$('[data-vbx-opt]').forEach(function (el) {
        var on = Number(el.dataset.vbxOpt) === state.opt;
        el.setAttribute('aria-checked', String(on));
        el.tabIndex = on ? 0 : -1;
      });
      setText('[data-vbx-add-price]', c.price);
      setText('[data-vbx-sprice]', c.price);
      setText('[data-vbx-scompare]', c.compare);
      setText('[data-vbx-snote]', c.note);
      setText('[data-vbx-sline]', c.line);
      addBtns.forEach(function (b) { b.disabled = !c.ok; });
      if (addLabel) addLabel.textContent = c.ok ? defaultAddText : (soonText || defaultAddText);
      root.classList.toggle('is-unavailable', !c.ok);
      root.dispatchEvent(new CustomEvent('venze:buybox', { bubbles: true, detail: { opt: state.opt, price: c.price } }));
    }

    function setText(sel, val) {
      var el = $(sel);
      if (el) el.textContent = val || '';
    }

    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-vbx-switch]');
      if (sw) { e.stopPropagation(); state.opt = Number(sw.dataset.vbxSwitch); render(); return; }
      var optEl = e.target.closest('[data-vbx-opt]');
      if (optEl) { state.opt = Number(optEl.dataset.vbxOpt); render(); return; }
      var add = e.target.closest('[data-vbx-add]');
      if (add) addToCart(add);
    });

    /* Teclado: flechas entre opciones; Espacio/Intro eligen */
    root.addEventListener('keydown', function (e) {
      var opt = e.target.closest('[data-vbx-opt]');
      if (!opt) return;
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); opt.click(); return; }
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      var group = $$('[data-vbx-opt]');
      var i = group.indexOf(opt) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
      var next = group[(i + group.length) % group.length];
      e.preventDefault();
      next.focus();
      next.click();
    });

    /* ── Añadir al carrito ── */
    async function addToCart(btn) {
      var t = current();
      if (!t || !t.ok || btn.disabled) return;
      var err = $('[data-vbx-error]');
      if (err) err.hidden = true;
      addBtns.forEach(function (b) { b.dataset.loading = 'true'; b.disabled = true; });

      var fd = new FormData();
      fd.append('id', t.variant);
      fd.append('quantity', '1');
      if (t.plan) fd.append('selling_plan', t.plan);
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
      if (ids.length) {
        fd.append('sections', ids.join(','));
        /* Sin sections_url, Shopify pinta las secciones como si fuera la raíz (mercado de España) y el carrito
           se pasaba a EUR en /sv-se (31 oct). Horizon hace lo mismo con la página actual. */
        fd.append('sections_url', window.location.pathname);
      }

      try {
        var res = await nativeFetch()((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/javascript' }, body: fd
        });
        if (!res.ok) throw new Error('add');
        var data = await res.json();
        /* Horizon 4.x: el carrito se actualiza con este evento (lee event.promise) */
        var ev = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true });
        ev.action = 'add'; ev.context = 'cart';
        ev.promise = Promise.resolve({ detail: { sections: (data && data.sections) || {}, items: data ? [data] : [], source: 'venze-buybox', didError: false } });
        document.dispatchEvent(ev);
        var drawer = document.querySelector('cart-drawer-component');
        var themeDrawer = drawer && drawer.closest('theme-drawer');
        if (themeDrawer && typeof themeDrawer.open === 'function') themeDrawer.open();
        else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      } catch (e) {
        if (err) err.hidden = false;
      } finally {
        addBtns.forEach(function (b) { b.dataset.loading = 'false'; });
        render();
      }
    }

    /* ── Línea de envío (hora de Madrid, días hábiles y festivos) ── */
    var ship = $('[data-vbx-ship]');
    if (ship) {
      var shipOut = ship.querySelector('[data-vbx-ship-text]') || ship;
      try { shipOut.textContent = shipText(ship.dataset); } catch (e) { /* se queda el texto sin fecha */ }
    }

    /* ── Reseña junto al botón: una a la vez, cada 7 s, en un hueco de alto fijo ── */
    var reviews = $$('[data-vbx-review]');
    if (reviews.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var ri = 0;
      setInterval(function () {
        if (document.hidden) return;
        reviews[ri].classList.remove('is-on');
        ri = (ri + 1) % reviews.length;
        reviews[ri].classList.add('is-on');
      }, 7000);
    }

    /* ── Visor de fotos: al tocar una foto se abre a pantalla completa, en esa misma foto ── */
    var zoom = $('[data-vbx-zoom]');
    if (zoom && typeof zoom.showModal === 'function') {
      var ztrack = zoom.querySelector('[data-vbx-zoom-track]');
      var zdots = Array.prototype.slice.call(zoom.querySelectorAll('.vbx-zoom__dots span'));
      var zmark = function () {
        var i = Math.round(ztrack.scrollLeft / Math.max(ztrack.clientWidth, 1));
        zdots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      };
      $$('.vbx-gallery__slide').forEach(function (sl, i) {
        sl.addEventListener('click', function () {
          zoom.showModal();
          document.documentElement.style.overflow = 'hidden';
          ztrack.scrollTo({ left: i * ztrack.clientWidth, behavior: 'instant' });
          zmark();
        });
      });
      ztrack.addEventListener('scroll', zmark, { passive: true });
      var zclose = function () { zoom.close(); };
      zoom.querySelector('[data-vbx-zoom-close]').addEventListener('click', zclose);
      zoom.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    }

    /* ── Escritorio: la caja va fija; si es más alta que la pantalla, se fija por abajo para que se vea entera ── */
    var box = $('.vbx-box');
    function stickyTop() {
      if (!box) return;
      var top = Math.min(88, window.innerHeight - box.offsetHeight - 24);
      root.style.setProperty('--vbx-sticky-top', top + 'px');
    }
    stickyTop();
    window.addEventListener('resize', stickyTop);
    $$('.vbx-faq__item').forEach(function (d) { d.addEventListener('toggle', stickyTop); });

    /* ── Píldora en móvil: siempre que el botón principal no se vea. En la ficha, desde el principio (foto y compra
       a la vista a la vez); en la home, pasado el hero (como la publicada) ── */
    var pill = $('[data-vbx-sticky]');
    var isPdp = root.dataset.pdp === '1';
    if (pill && mainAdd && 'IntersectionObserver' in window) {
      var mainVisible = true;
      var update = function () {
        var show = !mainVisible && (isPdp || window.scrollY > window.innerHeight * 0.6);
        pill.classList.toggle('is-on', show);
        pill.setAttribute('aria-hidden', String(!show));
        var b = pill.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) { mainVisible = entries[0].isIntersecting; update(); }).observe(mainAdd);
      window.addEventListener('scroll', update, { passive: true });
    }

    render();
  }

  /* Appstle sustituye window.fetch en las fichas y descarta selling_plan al añadir al carrito
     (ver snippets/venze-appstle-fix.liquid). Para /cart/add se usa el fetch nativo de un iframe
     limpio del mismo origen; el mismo iframe que crea ese snippet, si ya existe. */
  function nativeFetch() {
    try {
      var frame = document.getElementById('venze-native-ctx');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'venze-native-ctx';
        frame.title = '';
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('tabindex', '-1');
        frame.style.cssText = 'position:absolute;top:0;left:-9999px;width:1px;height:1px;border:0;visibility:hidden';
        (document.body || document.documentElement).appendChild(frame);
      }
      var ctx = frame.contentWindow;
      if (ctx && typeof ctx.fetch === 'function') return ctx.fetch.bind(ctx);
    } catch (e) { /* fetch de la página */ }
    return window.fetch.bind(window);
  }

  /* Fecha "de pared" de Madrid como día UTC, para sumar días sin líos de zona horaria */
  function madridNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), minutes: (+p.hour) * 60 + (+p.minute) };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }

  function shipText(ds) {
    var holidays = (ds.holidays || '').split(',').filter(Boolean);
    var isBiz = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && holidays.indexOf(iso(d)) === -1; };
    var nextBiz = function (d, n) { var x = d; while (n > 0) { x = addDays(x, 1); if (isBiz(x)) n--; } return x; };
    var cut = (ds.cutoff || '12:30').split(':');
    var cutMin = (+cut[0]) * 60 + (+cut[1] || 0);
    var now = madridNow();
    var today = isBiz(now.day) && now.minutes < cutMin;
    var shipDay = today ? now.day : nextBiz(now.day, 1);

    var locale = ds.locale || 'es';
    var wd = new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' });
    var long = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', timeZone: 'UTC' });
    var mon = new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' });
    var fmt = function (d, withMonth) {
      var s = wd.format(d).replace(/\.$/, '') + ' ' + d.getUTCDate();
      return withMonth ? s + ' ' + mon.format(d).replace(/\.$/, '') : s;
    };

    var first = (today ? ds.tToday || '' : ds.tLater || '').replace('[cutoff]', ds.cutoff).replace('[day]', long.format(shipDay).replace(',', ''));
    var range = ds.range;
    if (range !== 'es' && range !== 'eu') return ds.tNone;
    var mm = (range === 'es' ? ds.es : ds.eu).split('-');
    var from = nextBiz(shipDay, +mm[0]);
    var to = nextBiz(shipDay, +mm[1]);
    var crossMonth = from.getUTCMonth() !== to.getUTCMonth();
    var second = (range === 'es' ? ds.tEs : ds.tEu).replace('[from]', fmt(from, crossMonth)).replace('[to]', fmt(to, crossMonth));
    if (!first) return second.charAt(0).toUpperCase() + second.slice(1);
    return first + ', ' + second;
  }

  function boot() { document.querySelectorAll('[data-vbx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
